import { useAppStore } from '../../app/store/useAppStore';
import { Icon } from '../ui/Icon';

export function BottomNav({ active }: { active: 'home' | 'camera' | 'archive' | 'profile' }) {
  const navigate = useAppStore((state) => state.navigate);
  return <nav className="bottom-nav" aria-label="頁面導覽">
    <button className={active === 'home' ? 'active' : ''} onClick={() => navigate('HOME')}><Icon name="home"/><span>首頁</span></button>
    <button className={active === 'camera' ? 'active' : ''} onClick={() => navigate('CAMERA_INIT')}><Icon name="camera"/><span>拍照</span></button>
    <button className={active === 'archive' ? 'active' : ''} onClick={() => navigate('ARCHIVE')}><Icon name="archive"/><span>相簿</span></button>
    <button className={active === 'profile' ? 'active' : ''} onClick={() => navigate('PROFILE')}><Icon name="user"/><span>介紹</span></button>
  </nav>;
}
